module.exports = __webpack_public_path__ + "static/media/green.58786e91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belts/green.svg
// module id = 75
// module chunks = 0